import { Preferences } from "@capacitor/preferences";
import { useQuery } from "@tanstack/react-query";
import { motion } from "framer-motion";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { ANIMATION_DURATION } from "@/constants/animations.constants";
import { MobileViewportContainer } from "@/modules/onboarding/components/MobileViewportContainer/MobileViewportContainer";
import { OnboardingBackButton } from "@/modules/onboarding/components/OnboardingBackButton/OnboardingBackButton";
import { GenderPickerScreen } from "@/modules/onboarding/screens/GenderPickerScreen";
import { updateUserIfAuthenticated } from "@/modules/onboarding/utils/updateUserIfAuthenticated";
import { useUser } from "@/modules/user/useUser/useUser";
import { get } from "api";

const V3GenderPage = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const initialGender = user?.gender ?? "";

  const { data: platform } = useQuery({
    queryKey: ["/platform"],
    queryFn: () => get("/platform"),
  });

  const handleGenderSelect = useCallback(
    async (genderId: string) => {
      await Preferences.set({ key: "onboarding.gender", value: genderId });
      await updateUserIfAuthenticated({ gender: genderId });

      const isExistingUser = user?.completedProfile;
      const hasPersonalisationEnabled =
        platform?.platformSettings?.patientPersonalisationEnabled;

      if (isExistingUser && hasPersonalisationEnabled) {
        navigate("/personalise");
      } else {
        navigate("/signin/source");
      }
    },
    [
      navigate,
      user?.completedProfile,
      platform?.platformSettings?.patientPersonalisationEnabled,
    ]
  );

  return (
    <MobileViewportContainer
      header={<OnboardingBackButton prev="/signin/dob" />}
    >
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: ANIMATION_DURATION, delay: 0.1 }}
        className="flex w-full max-w-sm flex-col items-center"
      >
        <GenderPickerScreen
          key={`gender-${initialGender}`}
          onGenderSelect={handleGenderSelect}
          selectedGender={initialGender}
          submitButtonText="Confirm"
        />
      </motion.div>
    </MobileViewportContainer>
  );
};

export default V3GenderPage;
